import { NsDescriptionList } from 'components/common/ns-description-list/NsDescriptionList';
import { NsPrice } from 'components/common/ns-price/NsPrice';
import { FUEL_TYPES } from 'config/app-config';

type RateBreakDownProps = {
  til?: {
    monthlyAmount?: number;
    annualAmount?: number;
    unitRate?: number;
    unitRateDay?: number;
    unitRateDayName?: string;
    unitRateNight?: number;
    unitRateNightName?: string;
    standingCharge?: number;
  };
  fuel?: string;
  exitFee?: React.ReactNode;
  fillUnitRate?: boolean;
};

export const RateBreakDown = ({
  til,
  fuel,
  fillUnitRate
}: RateBreakDownProps) => {
  const fuelName = fuel === FUEL_TYPES.ELECTRIC ? 'Electricity' : 'Gas';

  if (!til) {
    return null;
  }

  return (
    <div>
      <h4>{fuelName} tariff costs</h4>
      <NsDescriptionList>
        {[
          {
            term: 'Estimated cost',
            description: (
              <p>
                <NsPrice amount={til.monthlyAmount || 0} /> / month
                <br />
                <NsPrice amount={til.annualAmount || 0} /> / year
              </p>
            )
          },
          {
            term: 'Unit rate',
            description: (
              <>
                {til.unitRate && (
                  <>
                    {til.unitRate}p per kWh <br />
                    {fillUnitRate && (
                      <>
                        <br />
                        <br />
                        <br />
                        <br />
                      </>
                    )}
                  </>
                )}
                {til.unitRateDay && (
                  <>
                    {til.unitRateDay}p per kWh <br />({til.unitRateDayName})
                    <br />
                    <br />
                  </>
                )}
                {til.unitRateNight && (
                  <>
                    {til.unitRateNight}p per kWh <br />({til.unitRateNightName})
                  </>
                )}
              </>
            )
          },

          {
            term: 'Standing charge',
            description: `${til.standingCharge}p per day `
          }
        ]}
      </NsDescriptionList>
    </div>
  );
};
